import { SERVER_URL, COMMON_HEADERS } from '@/config/serverUrl';

export interface AppAnnouncement {
  title: string;
  message: string;
}

export interface RuntimeConfig {
  minVersion: string;
  latestVersion: string;
  announcement: AppAnnouncement | null;
  maintenance: {
    active: boolean;
    message: string;
  };
}

/**
 * Public launch config. The token is optional, but when present the server uses
 * it to decide whether this account may bypass maintenance mode.
 */
export async function fetchRuntimeConfig(
  token: string | null,
  signal?: AbortSignal,
): Promise<RuntimeConfig> {
  const res = await fetch(`${SERVER_URL}/config`, {
    headers: {
      ...COMMON_HEADERS,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    credentials: 'include',
    cache: 'no-store',
    signal,
  });
  if (!res.ok) throw new Error(`RUNTIME_CONFIG_${res.status}`);

  const raw = (await res.json()) as Partial<RuntimeConfig>;
  const rawAnnouncement = raw.announcement;
  const announcement =
    rawAnnouncement
    && typeof rawAnnouncement.title === 'string'
    && typeof rawAnnouncement.message === 'string'
      ? {
          title: rawAnnouncement.title,
          message: rawAnnouncement.message,
        }
      : null;

  return {
    minVersion: typeof raw.minVersion === 'string' ? raw.minVersion : '0.0.0',
    latestVersion: typeof raw.latestVersion === 'string' ? raw.latestVersion : '0.0.0',
    announcement,
    maintenance: {
      active: Boolean(raw.maintenance?.active),
      message: typeof raw.maintenance?.message === 'string'
        ? raw.maintenance.message
        : '',
    },
  };
}
